export default __webpack_public_path__ + "415fbfcb19dfb26385f332e3e0aebe64.png";